import { useState, useCallback } from 'react'
import api from '@/shared/lib/api'

interface SDIInsight {
  summary: string
  opportunity_text: string
  budget_recommendation: string
  risks: string[]
}

interface SDIInsightInput {
  market_name: string
  market_size: number
  capture_rate: number
  budget_current: number
  budget_linear: number
  capture_elastic: number
  top_opportunities: Array<{ keyword?: string; opportunity_score?: number }>
}

export function useAISDIInsight() {
  const [insight, setInsight] = useState<SDIInsight | null>(null)
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)
  const [lastGenerated, setLastGenerated] = useState<Date | null>(null)

  const generate = useCallback(async (input: SDIInsightInput) => {
    setIsLoading(true)
    setError(null)
    try {
      const { data } = await api.post('/ai/sdi-insight', {
        market_name: input.market_name,
        market_size: input.market_size,
        capture_rate: input.capture_rate,
        budget_current: input.budget_current,
        budget_linear: input.budget_linear,
        capture_elastic: input.capture_elastic,
        top_opportunities: input.top_opportunities,
      })
      setInsight(data.data)
      setLastGenerated(new Date())
    } catch (err: any) {
      setError(err?.response?.data?.detail || 'Erreur lors de la génération.')
    } finally {
      setIsLoading(false)
    }
  }, [])

  const reset = useCallback(() => {
    setInsight(null)
    setError(null)
    setLastGenerated(null)
  }, [])

  return { generate, insight, isLoading, error, lastGenerated, reset }
}
